import { Box, Button, Typography, type BoxProps, type ButtonProps, type TypographyProps } from '@mui/material'
import { grey } from '@mui/material/colors'
import { styled } from '@mui/material/styles'
import { type ComponentType } from 'react'

type PillProps = ButtonProps & {
	selected: boolean,
}

type PillNumberProps = BoxProps & {
	selected: boolean,
}

export const Pill: ComponentType<PillProps> = styled( Button, {
	shouldForwardProp: ( prop ) => ![ 'selected' ].includes( prop as string ),
} )<PillProps>( ( { theme, selected } ) => ( {
	borderRadius: '999px',
	padding: `${theme.spacing( 0.5, 1, 0.5, 2 )}`,
	minWidth: 'auto',
	borderColor: selected ? '#6C63FF' : '#E0E0E0',
	backgroundColor: selected ? theme.palette.text.primary : 'transparent',
	color: selected ? 'white' : theme.palette.text.primary,
} ) )

export const PillText: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	marginRight: theme.spacing( 1 ),
	fontWeight: theme.typography.fontWeightMedium,
} ) )

export const PillNumber: ComponentType<PillNumberProps> = styled( Box, {
	shouldForwardProp: ( prop ) => ![ 'selected' ].includes( prop as string ),
} )<PillNumberProps>( ( { theme, selected } ) => ( {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: theme.spacing( 3 ),
	padding: `0 ${theme.spacing( 1 )}`,
	backgroundColor: selected ? 'white' : grey[ 300 ],
	color: theme.palette.text.primary,
	borderRadius: theme.spacing( 2 ),
} ) )
